'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  REQUEST_SEAT_UPGRADE: 'requestSeatUpgrade',
  REQUEST_SEAT_UPGRADE_BANNER: 'requestSeatUpgradeBanner',
  REQUEST_ADDITIONAL_SEATS: 'requestAdditionalSeats',
  REQUEST_SEAT_BANNER: 'requestSeatBanner',
  REQUEST_SKU: 'requestSKU',
  REQUEST_TRIAL: 'requestTrial',
  REQUEST_PRODUCT: 'requestProduct',
  REQUEST_QUOTE: 'requestQuote',
  REQUEST_PARTNER: 'requestPartnerScope',
  DEFAULT: 'default'
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.1086/js/_core/common/constants/AdminModalTypes.js
// module id = 130
// module chunks = 3 4 5